var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 10.7793V19.7793C5 20.3316 5.44772 20.7793 6 20.7793H8V16.7793C8 15.6748 8.89543 14.7793 10 14.7793H14C15.1046 14.7793 16 15.6748 16 16.7793V20.7793H18C18.5523 20.7793 19 20.3316 19 19.7793V10.7793H21V10.3L12 4L3 10.3V10.7793L5 10.7793ZM2 9.77934L11.4265 3.18077C11.7709 2.93974 12.2291 2.93974 12.5735 3.18077L22 9.77934V10.7793C22 11.3316 21.5523 11.7793 21 11.7793H20V19.7793C20 20.8839 19.1046 21.7793 18 21.7793H15V16.7793C15 16.2271 14.5523 15.7793 14 15.7793H10C9.44772 15.7793 9 16.2271 9 16.7793V21.7793H6C4.89543 21.7793 4 20.8839 4 19.7793V11.7793H3C2.44772 11.7793 2 11.3316 2 10.7793V9.77934Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e8d5029e.svg";
export { ForwardRef as ReactComponent };